import React from 'react';
import { Provider } from 'react-redux';
import { store } from '../../../../../../../../../../../../packs/napoleon';

import PopupContent from './components/PopupContent';

const PropertyPopup = ({ property }) => {
  return (
    <Provider store={store}>  
      <PopupContent property={property} />
    </Provider>
  );
};

export default PropertyPopup;
